export function getEnumKey(value: string | number, enumObj: any): string {
    for (const key in enumObj) {
        if (enumObj[key] === value && isNaN(Number(key))) {
            return key;
        }
    }
    return "";
}

export function getEnumValue(key: string, enumObj: any): string {
    const value = enumObj[key];
    return value !== undefined ? value.toString() : "";
}




